import { AfterViewInit, Component, ElementRef, Input, ViewChild, ViewEncapsulation } from '@angular/core';
import { ChatItem } from 'common/workitems/interfaces/chat-item.interface';
import { FullScreenHandlerService } from 'shared/services/full-screen-handler/full-screen-handler.service';
import { chatPanelAnimation } from 'components/work-item-lane-list/work-item-lane/work-item-widget/chat-widget/remote-control-panel/animations/chat-panel.animation';
import { WindowService } from 'shared/services/window/window.service';
import { BcConfigService } from 'common/config/provider';
import { RemoteControlService } from 'components/work-item-lane-list/work-item-lane/work-item-widget/chat-widget/remote-control-panel/remote-control.service';

@Component({
  selector: 'app-remote-control-panel',
  templateUrl: './remote-control-panel.component.html',
  styleUrls: ['./remote-control-panel.component.scss'],
  animations: [chatPanelAnimation],
  encapsulation: ViewEncapsulation.None
})
export class RemoteControlPanelComponent implements AfterViewInit {
  @Input()
  workItem: ChatItem;

  @ViewChild('rcWrapper', { static: true })
  rcWrapper: ElementRef;

  public canShowChatInRC: boolean;
  public isChatMinimized: boolean = true;

  constructor(private _config: BcConfigService, private _window: WindowService,
              private _remoteControlService: RemoteControlService) {
    this.canShowChatInRC = this._config.current.features.showChatInRC;
  }

  ngAfterViewInit(): void {
    this._remoteControlService.addTemporaryTrialTokens();
  }

  isRCFullScreen(): boolean {
    return this.rcWrapper && this.rcWrapper.nativeElement && FullScreenHandlerService.getFullscreenElement() === this.rcWrapper.nativeElement;
  }

  toggleChatMinimized(): void {
    this.isChatMinimized = !this.isChatMinimized;
  }

  onAnimationStart(animationEvent): void {
    if (!this.rcWrapper || !this.rcWrapper.nativeElement) {
      return;
    }
    const chatContainer = animationEvent.element;
    if (!chatContainer) {
      return;
    }

    const dragElement = this.rcWrapper.nativeElement.querySelector('[cdkDrag]');
    if (!dragElement) {
      return;
    }

    const dragElementRect = dragElement.getBoundingClientRect();
    const chatContainerRect = chatContainer.getBoundingClientRect();
    const expandedHeight = Math.min(800, this._window.innerHeight * 0.7);
    if (animationEvent.toState === 'expanded' && dragElementRect.top + dragElementRect.height < expandedHeight ||
      animationEvent.toState === 'minimized' && this._window.innerHeight - dragElementRect.top - dragElementRect.height < 0) {
      // Collapse to top when element would otherwise fall outside screen bounds
      chatContainer.style.bottom = '';
      chatContainer.style.top = chatContainerRect.top + 'px';
    } else {
      // Collapse to bottom by default
      chatContainer.style.bottom = (this._window.innerHeight - chatContainerRect.top - chatContainerRect.height) + 'px';
      chatContainer.style.top = '';
    }
  }
}
